import { Context } from "./context";
import * as cv from "../opencv.js";
import React, { useState, useEffect, useRef } from "react";
import * as RB from "react-bootstrap";
import { wrapLoading } from "./loading-animation";
export const ThresholdProps = (props) => {
    const defaultAuto = false;
    const defaultMode = "global";
    const defaultThresh = 127;
    const defaultRadius = 51;
    const defaultCnst = 30;

    const [isAuto, setIsAuto] = useState(defaultAuto);
    const [mode, setMode] = useState(defaultMode);
    const [thresh, setThresh] = useState(defaultThresh);
    const [radius, setRadius] = useState(defaultRadius);
    const [cnst, setCnst] = useState(defaultCnst);
    const [adptMode, setAdptMode] = useState("mean"); // also can be gauss

    const threshRef = useRef(defaultThresh);
    const radiusRef = useRef(defaultRadius);
    const cnstRef = useRef(defaultCnst);


    const valueRowRef = useRef();
    /**@type {Context} */
    const context = props.context;
    const onCheckChange = () => {
        setIsAuto(!isAuto);
    };
    const changeMode = (keyEvent) => {
        if (keyEvent === "global") {
            setMode("global");
        } else {
            setMode("adaptive");
        }
    };
    /**@param {InputEvent} event */
    const threshOnBlur = (event) => {
        let val = Math.round(Number(event.target.value));
        if (val < 0 || val > 255) {
            setThresh(threshRef.current);
            return;
        }
        setThresh(val);
        threshRef.current = val;
    };
    const radiusOnBlur = (event) => {
        let val = Math.round(Number(event.target.value));
        let ksize = 2 * val + 1;
        if (val < 0) {
            setRadius(radiusRef.current);
            return;
        }
        setRadius(val);
        radiusRef.current = val
    };
    const cnstOnBlur = (event) => {
        let val = Math.round(Number(event.target.value));
        if (val < 0 || val > 255) {
            setCnst(cnstRef.current);
            return;
        }
        setCnst(val);
        cnstRef.current = val;
    };
    const adptModeOnChange = (event) => {
        setAdptMode(event.target.value);
    };
    const resetOnClick = (event) => {
        setMode(defaultMode);
        setIsAuto(defaultAuto);
        setThresh(defaultThresh);
        setRadius(defaultRadius);
        setCnst(defaultCnst);
    };
    const binarize = () => {
        let w = context.offScrCnv.width,
            h = context.offScrCnv.height;
        let data = context.offScrCnvCtx.getImageData(0, 0, w, h);

        let src = cv.matFromImageData(data);
        let tmp = new cv.Mat();
        cv.cvtColor(src, tmp, cv.COLOR_RGBA2GRAY, 0);
        if (mode === "global") {
            let otsu = isAuto ? cv.THRESH_OTSU : 0;
            let r = cv.threshold(
                tmp,
                src,
                thresh,
                255,
                cv.THRESH_BINARY | otsu
            );
        } else if (mode === "adaptive") {
            let adptMeth =
                adptMode === "mean"
                    ? cv.ADAPTIVE_THRESH_MEAN_C
                    : cv.ADAPTIVE_THRESH_GAUSSIAN_C;
            cv.adaptiveThreshold(
                tmp,
                src,
                255,
                adptMeth,
                cv.THRESH_BINARY,
                radius * 2 + 1,
                cnst
            );
        }
        cv.cvtColor(src, tmp, cv.COLOR_GRAY2RGBA);
        let res = new ImageData(w, h);
        res.data.set(tmp.data);
        src.delete();
        tmp.delete();
        return res;
    };
    const applyOnClick = (event) => {
        wrapLoading(() => {
            console.time("Binarize");
            let newData = binarize();
            console.timeEnd("Binarize");
            context.offScrCnvCtx.putImageData(newData, 0, 0);
            context.updateImage();
            context.putToHistory();
        });
    };
    const form = (
        <RB.Form>
            <RB.FormGroup className="toolprop">
                <RB.Tabs
                    id="threshold-tabs"
                    activeKey={mode}
                    style={{ marginBottom: "1rem" }}
                    onSelect={changeMode}
                >
                    <RB.Tab eventKey="global" title="Глобальная">
                        <RB.Form.Row>
                            <RB.Form.Check
                                onChange={onCheckChange}
                                type="switch"
                                checked={isAuto}
                                id="threshold-value-auto"
                                label="Авто"
                            />
                        </RB.Form.Row>
                        <RB.Form.Row
                            className={isAuto ? "deactivated" : ""}
                            ref={valueRowRef}
                            id="value-row"
                        >
                            <RB.Col>
                                <RB.Form.Label>Порог:</RB.Form.Label>
                            </RB.Col>
                            <RB.Col md={7}>
                                <RB.Form.Control
                                    type="number"
                                    size="sm"
                                    value={thresh}
                                    onChange={(e)=>{setThresh(e.target.value)}}
                                    onBlur={threshOnBlur}
                                    id="threshold-value"
                                ></RB.Form.Control>
                            </RB.Col>
                        </RB.Form.Row>
                    </RB.Tab>
                    <RB.Tab eventKey="adaptive" title="Адаптивная">
                        <RB.Form.Row>
                            <RB.Col>
                                <RB.Form.Label>Радиус:</RB.Form.Label>
                            </RB.Col>
                            <RB.Col md={7}>
                                <RB.Form.Control
                                    type="number"
                                    size="sm"
                                    value={radius}
                                    onChange={(e)=>{setRadius(e.target.value)}}
                                    onBlur={radiusOnBlur}
                                    id="threshold-radius"
                                ></RB.Form.Control>
                            </RB.Col>
                        </RB.Form.Row>
                        <RB.Form.Row>
                            <RB.Col>
                                <RB.Form.Label>C:</RB.Form.Label>
                            </RB.Col>
                            <RB.Col md={7}>
                                <RB.Form.Control
                                    type="number"
                                    size="sm"
                                    value={cnst}
                                    onChange={(e)=>{setCnst(e.target.value)}}
                                    onBlur={cnstOnBlur}
                                    id="threshold-c"
                                ></RB.Form.Control>
                            </RB.Col>
                        </RB.Form.Row>
                        <RB.Form.Row>
                            <RB.Col>
                                <RB.Form.Label>Тип:</RB.Form.Label>
                            </RB.Col>
                            <RB.Col md={7}>
                                <RB.FormControl
                                    size="sm"
                                    onChange={adptModeOnChange}
                                    value={adptMode}
                                    as="select"
                                >
                                    <option value="mean">Среднее</option>
                                    <option value="gauss">
                                        Гауссова сумма
                                    </option>
                                </RB.FormControl>
                            </RB.Col>
                        </RB.Form.Row>
                    </RB.Tab>
                </RB.Tabs>
                <RB.Form.Row className="button-row">
                    <RB.Button
                        id="threshold-apply"
                        size="sm"
                        onClick={applyOnClick}
                    >
                        Применить
                    </RB.Button>
                    <RB.Button
                        id="threshold-reset"
                        size="sm"
                        onClick={resetOnClick}
                    >
                        Сброс
                    </RB.Button>
                </RB.Form.Row>
            </RB.FormGroup>
        </RB.Form>
    );
    return form;
};
